import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import Link from '@/components/link/link'

import * as styles from './background4.module.scss'

type Props = {
  image: {
    gatsbyImageData: Record<string, unknown> | null
    alt: string | null
  } | null
  headline: string
  date?: string
  description?: string
  pretitle?: string
  pretitleLink?: string
}

const HeaderBackgroundV4: React.FC<Props> = (props) => {
  const { image, date, headline, description, pretitle, pretitleLink } = props
  return (
    <div className={styles.background4}>
      <div className={styles.inner}>
        <div className={styles.box}>
          {pretitle && (
            <div className={styles.pretitle}>
              <Link to={pretitleLink ?? ''}>{pretitle}</Link>
            </div>
          )}
          <div className={styles.boxInner}>
            <div>
              {date && <p>{date}</p>}
              <h1>{headline}</h1>
            </div>
            <div>
              {description && (
                <div dangerouslySetInnerHTML={{ __html: description }} />
              )}
            </div>
          </div>
        </div>
        <GatsbyImage
          image={image?.gatsbyImageData as unknown as IGatsbyImageData}
          alt={headline}
          className={styles.image}
          objectFit="contain"
        />
      </div>
    </div>
  )
}

export default HeaderBackgroundV4
